// extracted by mini-css-extract-plugin
export var installCode = "GetStarted-module--installCode--2-Ykx";
export var lightInstallCode = "GetStarted-module--lightInstallCode--1rUYD";
export var copyButton = "GetStarted-module--copyButton--2Zctn";